import { observable, action, computed } from 'mobx'
import { InventoryLogType } from '@getgreenline/inventory/build/models/inventoryLog'

export class UpdateInventory {
  @observable
  mode?: 'set' | 'add' | 'subtract'

  @observable
  quantity?: number = undefined

  @observable
  mostRecentQuantity?: number

  @observable
  type?: InventoryLogType

  @observable
  notes?: string

  @observable
  batchId: number | undefined = undefined

  @observable
  newLowStockQuantity?: number | null

  @observable
  newReStockQuantity?: number | null

  @action
  setMode(mode?: 'set' | 'add' | 'subtract') {
    this.mode = mode
    this.quantity = undefined
    this.type = undefined
    this.notes = undefined
    this.batchId = undefined
    if (mode === 'set' || mode === 'add') {
      this.type = InventoryLogType.AUDIT
    } else {
      this.type = undefined
    }
  }

  @action
  setQuantity(quantity: number | undefined) {
    if (quantity === undefined || isNaN(quantity) || quantity === null) {
      this.quantity = undefined
    } else if (this.mode === 'add') {
      this.quantity = Math.abs(quantity)
    } else if (this.mode === 'subtract') {
      this.quantity = Math.abs(quantity) * -1
    } else {
      this.quantity = quantity
    }
  }

  @action
  setMostRecentQuantity(newQuantity: number) {
    isNaN(newQuantity)
      ? (this.mostRecentQuantity = undefined)
      : (this.mostRecentQuantity = newQuantity)
  }

  @action
  setType(type?: InventoryLogType) {
    this.type = type
  }

  @action
  setNotes(notes?: string) {
    this.notes = notes
  }

  @action
  setBatchId(batchId: number | undefined) {
    this.batchId = batchId
  }

  @action
  setNewLowStockQuantity(newLowStockQuantity: number | undefined | null) {
    this.newLowStockQuantity = newLowStockQuantity
  }

  @action
  setNewReStockQuantity(newReStockQuantity: number | undefined | null) {
    this.newReStockQuantity = newReStockQuantity
  }

  @computed
  get availableInventoryTypes(): InventoryLogType[] {
    if (this.mode) {
      if (this.mode === 'set') {
        return [InventoryLogType.AUDIT]
      } else if (this.mode === 'add') {
        return [InventoryLogType.AUDIT]
      } else if (this.mode === 'subtract') {
        return [
          InventoryLogType.RETURN,
          InventoryLogType.DESTROYED,
          InventoryLogType.LOST,
          InventoryLogType.AUDIT,
        ]
      } else {
        return []
      }
    } else {
      return []
    }
  }
}
